import ToastSuccessIcon from './ToastSuccessIcon'

export default ToastSuccessIcon